<!--<div class="coupon-layout google-coupon">
    <div class="adcore-logo last-step"><a href="https://www.adcore.com" target="_blank"><i></i></a></div>
    <div class="show-coupon">
        <div class="confetti-cover" *ngIf="showConfetti"></div>
        <div class="image"></div>
        <div class="content">
          <div *ngIf="action === 'link'">
            <span>Coupon request successfully submitted!</span>
          </div>
          <div *ngIf="action === 'create'">
            <span>Account creation request successfully submitted!</span>
          </div>
        </div>
        <div class="video-mobile-view">
            <app-ad-video [showVideo]="true" title="Where do I see my coupon?" [isMobile]="true" videoName="google-video"></app-ad-video>
        </div>
        <div class="video-desk-view">
            <app-ad-video [showVideo]="showVideo" title="Where do I see my coupon?" [isMobile]="false" videoName="google-video"></app-ad-video>
        </div>
        <div class="google-ad-text">
          <div *ngIf="action === 'link'">
            If your account is eligible, it may take up-to 35 days for the coupon to be applied by Google.<br class="space"> For more information on account eligibility and promotional codes policy, please refer to Google’s <a href="https://support.google.com/adspolicy/answer/1396257?hl=en" target="_blank"><span class="desktop-label">terms and conditions</span><span class="mobile-label">T&Cs</span></a>.
          </div>
          <div *ngIf="action === 'create'">
            Thank you for requesting an account with Couponer! If your domain meets the qualifications, we will notify you via email. Upon approval, it may take up to 35 days for Google to apply the coupon. For more information on account eligibility and promotional code policies, please refer to Google's  <a href="https://support.google.com/adspolicy/answer/1396257?hl=en" target="_blank"><span class="desktop-label">terms and conditions</span><span class="mobile-label">T&Cs</span></a>.
          </div>
        </div>
        <div class="buttons">
            <div class="get-coupon-btn"><a href="https://couponer.app/ms" target="_blank"><span class="icon-box"><i></i></span><span class="text">Get $400 Microsoft Ads coupon</span></a></div>
            <span class="or desktop">Or</span>
            <div class="another-acc-btn"><p-button styleClass="link-btn" label="Link another Google account" (onClick)="linkAccount()"></p-button></div>
            <div class="or mobile">Or</div>
        </div>
        <div class="apps-main-title">Try out some of our other apps</div>
        <div class="apps">
            <app-items-app [lang]="'en'" src="google"></app-items-app>
        </div>
    </div>
    <app-questions [listItemsType]="'google'" [title]="'Q&A'" [isLastStep]="true"></app-questions>
    <app-footer [lang]="'en'"></app-footer>
</div> -->

<div class="coupon-layout fixed-header">
  <app-header></app-header>
  <div class="main-content">
      <div>
          <div>
            <div class="coupon-layout google-coupon">
              <div class="show-coupon">
                <div><i class="gl-palette main-logo"></i></div>
                <div class="content">
                  <div>
                    <div *ngIf="action === 'link'">
                      <span>Coupon request successfully submitted!</span>
                    </div>
                    <div *ngIf="action === 'create'">
                      <span>Account creation request successfully submitted!</span>
                    </div>
                  </div>
                </div>
                <div class="google-ad-text">
                  <div *ngIf="action === 'link'">
                    If your account is eligible, it may take Google up to 35 days to apply the coupon.<br class="space"> For details on eligibility and promotional codes, see <a href="https://support.google.com/adspolicy/answer/1396257?hl=en" target="_blank"><span>Google’s T&Cs.</span></a>
                  </div>
                  <div *ngIf="action === 'create'">
                    Thank you for requesting an account with Couponer! If your domain meets the qualifications, we will notify you via email. Upon approval, it may take up to 35 days for Google to apply the coupon. For more information on account eligibility and promotional code policies, please refer to Google's  <a href="https://support.google.com/adspolicy/answer/1396257?hl=en" target="_blank"><span class="desktop-label">terms and conditions</span><span class="mobile-label">T&Cs</span></a>.
                  </div>
                </div>
                <div class="popular-coupon">
                  <h3>Get Microsoft Advertising coupon</h3>
                  <div class="coupon-box-large-layout">
                    <app-coupon-box [listItem]="this.data.popularCouponItem" [isSecondaryLayout]="true" (redeemEvent)="this.data.goToCoupon('3')"></app-coupon-box>
                  </div>
                </div>
                <div class="buttons">
                  <!--<div class="get-coupon-btn"><a href="https://couponer.app/ms" target="_blank"><span class="icon-box"><i></i></span><span class="text">Get $400 Microsoft Ads coupon</span></a></div>-->
                  <span class="or">Or</span>
                  <div class="another-acc-btn"><p-button styleClass="link-btn" label="Link another Google account" (onClick)="linkAccount()"></p-button></div>
                  <!--<div class="or mobile">Or</div>-->
                </div>
              </div>
            </div>
            
            <h3 class="explore-title">Explore all coupons</h3>
              <div class="coupon-layout-home-body">
                  <app-all-coupons></app-all-coupons>
              </div>
          </div>
      </div>
      <app-footer [lang]="'en'"></app-footer>
  </div>
</div>
